import {
  BodyRow,
  ListItemAvatar,
  ListItemText,
} from 'app/components/ChakraTableList';
import { SongCover } from 'app/components/Song/SongCover';
import { getAvatarImage } from 'app/utils/utils';
import { LabelV2Version } from 'types/releases';
import { SongStatusType } from 'types/song';
import { getConnexValidationMessage } from '../../utils';
import { GoToSong } from '../../ReleaseErrorMsg';

export const getRows = (
  version?: LabelV2Version,
  songStatus: SongStatusType = SongStatusType.IN_CREATION
) =>
  (version?.validationErrors || []).reduce(
    (acc, { errorCode, contributionGuid }) => {
      const issue = (
        <ListItemText
          data-testid="issue-text"
          primary={getConnexValidationMessage(errorCode)}
        />
      );
      const songTitle = (
        <ListItemText data-testid="issue-text" primary={version?.song.title} />
      );

      const snapshot = version?.contributions?.find(
        ({ contributionGuid: guid }) => contributionGuid === guid
      )?.snapshot;

      const profileCard = snapshot?.contributor?.profileCard;

      const avatar = (
        <ListItemAvatar
          src={getAvatarImage(profileCard?.profileImages)}
          initials={profileCard?.initials}
          colors={profileCard?.avatarColors}
        />
      );
      const contribution = (
        <ListItemText
          primary={profileCard?.displayName}
          secondary={snapshot?.className}
          primaryTextProps={{
            lineHeight: 'normal',
          }}
          secondaryTextProps={{
            color: 'textSubdued',
          }}
        />
      );

      const songCover = <SongCover size="medium" status={songStatus} />;

      switch (errorCode) {
        case 'MISSING_SONG_DISPLAY_ARTIST_NAME': {
          acc.push({
            avatar: songCover,
            title: songTitle,
            issue,
            link: (
              <GoToSong
                tab="details"
                focus="displayArtistName"
                releaseVersion={version}
              />
            ),
          });
          break;
        }
        case 'MISSING_CONTRIBUTION_ROLE': {
          acc.push({
            avatar,
            title: contribution,
            issue,
            link: <GoToSong tab="contributions" releaseVersion={version} />,
          });
          break;
        }
        case 'INVALID_CONTRIBUTION_ROLE': {
          acc.push({
            avatar,
            title: contribution,
            issue,
            link: <GoToSong tab="contributions" releaseVersion={version} />,
          });
          break;
        }
        case 'MISSING_SONG_GENRE': {
          acc.push({
            avatar: songCover,
            title: songTitle,
            issue,
            link: (
              <GoToSong
                tab="details"
                focus="song-genre"
                releaseVersion={version}
              />
            ),
          });
          break;
        }
        case 'INVALID_SONG_GENRE': {
          acc.push({
            avatar: songCover,
            title: songTitle,
            issue,
            link: (
              <GoToSong
                tab="details"
                focus="song-genre"
                releaseVersion={version}
              />
            ),
          });
          break;
        }
        case 'MISSING_NON_SONGWRITER_CONTRIBUTION': {
          acc.push({
            avatar: songCover,
            title: songTitle,
            issue,
            link: <GoToSong tab="contributions" releaseVersion={version} />,
          });
          break;
        }
        case 'INVALID_SPLIT': {
          acc.push({
            avatar: songCover,
            title: songTitle,
            issue,
            link: <GoToSong tab="splits" releaseVersion={version} />,
          });
          break;
        }
        default:
      }
      return acc;
    },
    [] as BodyRow[]
  );
